var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refinance-row"},[_c('div',{staticClass:"cell"},[_c('h5',[_vm._v(_vm._s(_vm.createdAtText))])]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('h5',[_vm._v(_vm._s(_vm.activity.title))])]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('h5',[_vm._v(_vm._s(_vm.admin.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }